import { ROOT_STRUCT_CODE } from '../constants';

/**
 * Параметр адресации атрибута по родительской структуре для запросов одного атрибута:
 * чтения, изменения, удаления и восстановления. Код атрибута уникален только в пределах родителя,
 * а без параметра бэкенд ищет атрибут среди корневых — вложенному атрибуту параметр нужен
 * в каждом из этих запросов, корневому не нужен.
 */
export const getParentStructParams = (
  parentStructCode?: string | null,
): { 'parent-struct-code': string } | undefined =>
  parentStructCode && parentStructCode !== ROOT_STRUCT_CODE ? { 'parent-struct-code': parentStructCode } : undefined;
